import { useRef } from 'react'

interface VideoPlayerProps {
  embedUrl: string
  title?: string
  autoplay?: boolean
  onPlay?: () => void
  onPause?: () => void
  onEnded?: () => void
  onTimeUpdate?: (time: number) => void
  className?: string
}

export default function VideoPlayer({
  embedUrl,
  title = 'Video',
  autoplay = false,
  className = '',
}: VideoPlayerProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  // Build embed URL with parameters
  const fullUrl = new URL(embedUrl)
  if (autoplay) {
    fullUrl.searchParams.set('autoplay', 'true')
  }

  return (
    <div className={`relative aspect-video bg-slate-800 rounded-xl overflow-hidden ${className}`}>
      <iframe
        ref={iframeRef}
        src={fullUrl.toString()}
        title={title}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full border-0"
      />
    </div>
  )
}
